(function () {
  'use strict';

  /* Geräteklasse-Map: Varianten-Optionswert -> Pill-Darstellung.
     Identisch zur Liquid-Logik in snippets/th-quality-current.liquid.
     01.09.2026 (P5-3.6): Shopify übersetzt die Optionswerte mit, live
     gemessen "Neu" / "New" / "Nouveau". Ohne diese Aliasse blendete der
     Code den Badge beim ersten Variantenwechsel auf einem Neu-Produkt
     aus, weil der Schlüssel nicht in der Map stand. a, b und c sind
     sprachneutral. Beschriftungen kommen aus data-th-labels, damit hier
     kein deutscher Text mehr hartcodiert ist. */
  const MAP = {
    neu: { color: '#1B8FD5', key: 'neu' },
    new: { color: '#1B8FD5', key: 'neu' },
    nouveau: { color: '#1B8FD5', key: 'neu' },
    nuovo: { color: '#1B8FD5', key: 'neu' },
    a: { color: '#22C55E', key: 'a' },
    b: { color: '#F59E0B', key: 'b' },
    c: { color: '#6B7280', key: 'c' },
  };
  const FALLBACK_LABELS = { neu: 'Neu', a: 'A', b: 'B', c: 'C' };

  function init(container) {
    const index = parseInt(container.dataset.thZustandIndex, 10);
    if (!index) return;

    /* Übersetzte Beschriftungen und aria-Vorlage aus dem Markup. */
    let labels = FALLBACK_LABELS;
    try {
      const parsed = JSON.parse(container.dataset.thLabels || '');
      if (parsed && typeof parsed === 'object') labels = parsed;
    } catch (e) {
      labels = FALLBACK_LABELS;
    }
    const ariaTemplate = container.dataset.thAriaTemplate || 'Geräteklasse __CLASS__, Erklärung anzeigen';

    const trigger = container.querySelector('[data-th-quality-trigger]');
    const pill = container.querySelector('[data-th-quality-pill]');
    const pillLabel = pill && pill.querySelector('.th-quality-pill__label');
    if (!trigger || !pill || !pillLabel) return;

    // Produkt-Section ermitteln (für Scope + Varianten-JSON).
    const section = container.closest('section') || document;

    let variants = null;
    const selects = section.querySelector('variant-selects, variant-radios');
    if (selects) {
      const json = selects.querySelector('[type="application/json"]');
      if (json) {
        try {
          variants = JSON.parse(json.textContent);
        } catch (e) {
          variants = null;
        }
      }
    }
    if (!variants) return;

    function update(variantId) {
      const v = variants.find(function (x) {
        return String(x.id) === String(variantId);
      });
      if (!v || !v.options) return;
      const info = MAP[String(v.options[index - 1] || '').trim().toLowerCase()];
      // Unbekannte Klasse -> Badge ausblenden.
      if (!info) {
        container.style.display = 'none';
        return;
      }
      const label = labels[info.key] || FALLBACK_LABELS[info.key] || info.key.toUpperCase();
      container.style.display = '';
      trigger.setAttribute('data-th-quality-trigger', info.key);
      trigger.setAttribute('aria-label', ariaTemplate.replace('__CLASS__', label));
      pill.style.setProperty('--th-quality-color', info.color);
      pillLabel.textContent = label;
    }

    // Minion feuert beim Variantenwechsel ein change-Event am
    // input[name="id"] (global.js updateVariantInput), das bubbelt.
    document.addEventListener('change', function (event) {
      const input = event.target.closest && event.target.closest('input[name="id"]');
      if (!input) return;
      if (section !== document && !section.contains(input)) return;
      update(input.value);
    });
  }

  function boot() {
    document.querySelectorAll('[data-th-quality-current]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
